import { useState, useEffect } from 'react';
import '../styles/Navbar.css';


export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Menü açıkken body scroll'unu kapat
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const links = [
    { href: "#hizmetler", label: "Hizmetler" },
    { href: "#nasil-calisir", label: "Süreç" },
    { href: "#paketler", label: "Paketler" },
    { href: "#referanslar", label: "Referanslar" },
  ];

  return (
    <>
      <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
        <a href="#hero" className="navbar__logo">
          <span className="navbar__logo-mark">🐬</span>
          <span>
            Yunus<em>Medya</em>
          </span>
        </a>

        <ul className="navbar__links navbar__links--desktop">
          {links.map((l) => (
            <li key={l.href}>
              <a href={l.href}>{l.label}</a>
            </li>
          ))}

          <li>
            <a
              href="https://wa.me/905467698734"
              target="_blank"
              rel="noreferrer"
              className="navbar__cta"
            >
              Teklif Al
            </a>
          </li>
        </ul>

        <button
          className={`navbar__burger ${
            menuOpen ? "navbar__burger--open" : ""
          }`}
          onClick={() => setMenuOpen((m) => !m)}
          aria-label="Menü"
        >
          <span />
          <span />
          <span />
        </button>
      </nav>

      <div className={`mobile-menu ${menuOpen ? "mobile-menu--open" : ""}`}>
        <ul>
          {links.map((l) => (
            <li key={l.href}>
              <a href={l.href} onClick={() => setMenuOpen(false)}>
                {l.label}
              </a>
            </li>
          ))}

          <li>
            <a
              href="https://wa.me/905467698734"
              target="_blank"
              rel="noreferrer"
              className="mobile-menu__cta"
              onClick={() => setMenuOpen(false)}
            >
              Teklif Al
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}